import { SupportedFontsSVGIcons } from '../assets';

export const fontFamilies = [
  { key: 'Arial', text: 'Arial', svg: SupportedFontsSVGIcons.Arial },
  {
    key: 'Bahnschrift',
    text: 'Bahnschrift',
    svg: SupportedFontsSVGIcons.Bahnschrift,
  },
  { key: 'Calibri', text: 'Calibri', svg: SupportedFontsSVGIcons.Calibri },
  {
    key: 'Century Gothic',
    text: 'Century Gothic',
    svg: SupportedFontsSVGIcons['Century Gothic'],
  },
  {
    key: 'Comic Sans MS',
    text: 'Comic Sans MS',
    svg: SupportedFontsSVGIcons['Comic Sans MS'],
  },
  { key: 'Consolas', text: 'Consolas', svg: SupportedFontsSVGIcons.Consolas },
  { key: 'Garamond', text: 'Garamond', svg: SupportedFontsSVGIcons.Garamond },
  { key: 'Georgia', text: 'Georgia', svg: SupportedFontsSVGIcons.Georgia },
  {
    key: 'Gill Sans MT',
    text: 'Gill Sans MT',
    svg: SupportedFontsSVGIcons['Gill Sans MT'],
  },
  { key: 'Impact', text: 'Impact', svg: SupportedFontsSVGIcons.Impact },
  {
    key: 'Lucida Sans',
    text: 'Lucida Sans',
    svg: SupportedFontsSVGIcons['Lucida Sans'],
  },
  {
    key: 'Segoe UI',
    text: 'Segoe UI',
    svg: SupportedFontsSVGIcons['Segoe UI'],
  },
  { key: 'Tahoma', text: 'Tahoma', svg: SupportedFontsSVGIcons.Tahoma },
  {
    key: 'Times New Roman',
    text: 'Times New Roman',
    svg: SupportedFontsSVGIcons['Times New Roman'],
  },
  {
    key: 'Trebuchet MS',
    text: 'Trebuchet MS',
    svg: SupportedFontsSVGIcons['Trebuchet MS'],
  },
  { key: 'Verdana', text: 'Verdana', svg: SupportedFontsSVGIcons.Verdana },
];
